export const version = '0.806.0-SNAPSHOT'
export const chameleonWebVersion = '10.3.0'
export const chameleonCoreVersion = '7.12.1'
